import authSaga from './auth'
import employeeSaga from './employee'
import employeeProgramSaga from './employeeProgram'

import { all } from 'redux-saga/effects'

export default function* rootSaga() {
  yield all([authSaga(), employeeSaga(), employeeProgramSaga()])
}
